import React from 'react';

const AboutPage = () => {
    return (
        <div>
            <h1>About Us</h1>
            <p>About us content here.</p>
        </div>
    );
};

export default AboutPage;